import qs from "qs";
import apiClient from "./apiClient";

const memberSearchByNicknameAndGroupIdAPI = async (nickname: string, groupId?: string) => {
	const query = qs.stringify({ nickname, groupId });
	const res = await apiClient.get(`/api/admin/business/member/search?${query}`);
	return res.data;
};

const getMemberCarList = async (memberId: string) => {
	const res = await apiClient.get(`/api/admin/business/member/car/${memberId}`);
	return res.data;
};

const getMemberList = async (groupId: string) => {
	const query = qs.stringify({ groupId });
	const res = await apiClient.get(`/api/admin/common/group/member/list?${query}`);
	return res.data;
};

const memberAPI = {
	memberSearchByNicknameAndGroupIdAPI,
	getMemberCarList,
	getMemberList,
};

export default memberAPI;
